import { Box, Stack, Typography, useTheme } from "@mui/material";

type NavViewHeaderProps = {
  text?: string;
  children?: React.ReactNode;
};

const NavViewHeader = ({ text, children }: NavViewHeaderProps) => {
  const theme = useTheme();

  return (
    <Box
      sx={{
        padding: 1.5,
        bgcolor: theme.palette.background.paper,
        borderBottom: `1px solid ${theme.palette.divider}`,
      }}
    >
      <Stack
        direction="row"
        justifyContent="space-between"
        alignContent="center"
      >
        <Typography variant="h6" fontWeight="bold">
          {text}
        </Typography>
        <Stack direction="row" alignItems="center" gap={1}>
          {children}
        </Stack>
      </Stack>
    </Box>
  );
};
export default NavViewHeader;
